export const MAIN_COLOR = "#FFA101";
export const MAIN_LIGTH_COLOR = "#FCF4E7";
export const BLACK = "#151B25";
